import { openFullScreenOverlay, closeFullScreenOverlay } from "./FullScreenOverlaySlice"

console.log("Hello: ", openFullScreenOverlay, closeFullScreenOverlay)

export {openFullScreenOverlay, closeFullScreenOverlay}